import React from 'react';

// Styles & Assets
import styles from './CurrentZoneItems.module.css';

// Services
import { sortByAttribute } from '../../../services/sort';

// Interfaces
import { Bed, ITown } from '../../../interfaces/Patient';
import { ActionReducerZoneAdministration } from '../../../interfaces/Administration';

// Language
import { useTranslation } from 'react-i18next';
import SelectorZonesBed from '../SelectorZonesBed/SelectorZonesBed';

const CurrentZoneItems: React.FC<{
    items: (Bed | ITown)[] | null
    selectedItemsIDs: (Bed | ITown)['id'][]
    showBeds: boolean
    dispatchSelectedItems: React.Dispatch<ActionReducerZoneAdministration>
}> = ({ items, selectedItemsIDs, showBeds, dispatchSelectedItems }) => {

    const { t } = useTranslation();

    const handleSelect = (item: Bed | ITown) =>
        dispatchSelectedItems({ type: showBeds ? 'REMOVE_BEDS' : 'REMOVE_TOWNS', payload: item.id });

    return (
        <div className={styles.zoneInfo}>
            {items === null ?
                <div className={styles.noZoneSelected}>
                    <p>{t('select_zone_list')}</p>
                </div>
                :
                <div className={styles.zoneInfoRow}>
                    <h3 className={styles.columnZoneTitle}>
                        {showBeds ? t('beds') : t('towns')}
                    </h3>
                    <div className={styles.columnZoneContainer}>
                        <SelectorZonesBed
                            items={sortByAttribute(items, 'name')}
                            selectedItemsIDs={selectedItemsIDs}
                            handleSelect={handleSelect}
                        />
                    </div>
                </div>
            }
        </div>
    );
};

export default CurrentZoneItems;